<template>
  <div>
    <Header :window="window" :parameters="'client'" />
    <div :class="window.width < 480 ? 'container-fluid' : 'container'">
      <!-- bandeau -->
      <div
        class="background"
        :style="
          'margin-top:5px;' +
            background +
            ';height:' +
            (window.width > 1023 ? '250px' : '125px;')
        "
      >
        <h2
          style="color: white;mix-blend-mode: difference;text-align:center;font-size:24px;font-weight:lighter"
        >
          {{ insight_name }}
        </h2>
      </div>
      <div v-if="!is_finish" style="margin-top:5px; padding:10px;" class="bloc">
        <div>
          <b-icon pack="fas" icon="user"></b-icon>
          {{ $t("public.bienvenue") }} {{ this.firstname }}
          {{ this.lastname }} !
        </div>
        <vue-step
          :active-color="'#424A60'"
          :now-step="nowStep"
          :step-list="stepListCalc"
        ></vue-step>
        <!-- implémentation des buttons -->
        <div style="margin-bottom:20px;">
          <button
            style="margin-right: 5px;"
            :style="window.width < 480 ? 'width:100%;margin-top:5px;' : ''"
            class="button-client is-pulled-left"
            @click="toStep(prevStep, 'prev')"
            v-if="nowStep > 1"
          >
            {{ $t("question.precedent") }}
          </button>
          <button
            class="button-client is-pulled-right"
            :style="window.width < 480 ? 'width:100%;margin-top:5px;' : ''"
            @click="toStep(nextStep, 'next')"
            v-if="nowStep < stepListCalc.length && suivant == true"
          >
            {{ $t("question.suivant") }}
          </button>
          <button
            disabled
            class="button-client is-pulled-right"
            :style="window.width < 480 ? 'width:100%;margin-top:5px;' : ''"
            v-if="nowStep < stepListCalc.length && suivant == false"
          >
            {{ $t("question.suivant") }}
          </button>
          <button
            class="button-primary is-pulled-right"
            :style="window.width < 480 ? 'width:100%;margin-top:5px;' : ''"
            @click="validateResponse"
            v-if="nowStep == stepListCalc.length && suivant == true"
          >
            {{ $t("question.valider") }}
          </button>
          <br class="mt-1" />
        </div>
      </div>
      <!-- bloc de formulaire -->
      <div v-if="!is_finish" class="bloc">
        <div
          style="margin-top:5px;"
          v-for="(question, index) in insight_questions.questions"
          :key="question.id"
        >
          <transition name="fade" mode="out-in">
            <div class="bloc_question" v-show="index + 1 == nowStep">
              <!-- questions -->
              <div class="text-1-3">
                {{ question.id }} / {{ $t(question.q) }}
              </div>
              <hr class="hr" />
              <!-- Propositions draggables -->
              <span class="text-explicatif"
                >{{ $t("orderedChoices.instructions") }}{{ " " }}</span
              >
              <div>
                <button
                  v-if="!orderIsOk"
                  class="button is-info is-outlined is-small"
                  type="button"
                  @click="affichageSuivantOrderedChoices(question)"
                >
                  {{ $t("question.ordreConvient") }}
                </button>
              </div>
              <b-icon
                type="is-success"
                v-if="orderIsOk"
                pack="fas"
                icon="check fa-check"
                size="is-small"
              ></b-icon>
              <br />
              <table class="mt-1">
                <draggable
                  :list="question.prop"
                  class="list"
                  @change="affichageSuivantOrderedChoices()"
                >
                  <div
                    class="list-item ordered text-1-1"
                    v-for="proposition in insight_questions.questions[
                      nowStep - 1
                    ].prop"
                    :key="proposition.entitled"
                  >
                    <b-icon
                      style="color: #bdbeba"
                      pack="fas"
                      icon="sort"
                      size="is-small"
                    ></b-icon>
                    <input
                      type="checkbox"
                      class="orderedcheckbox"
                      :checked="!question.suivant"
                      :name="insight_questions.questions"
                      :value="proposition.c"
                      :id="'id' + proposition.id"
                    />
                    <label class="ordered" @click.prevent
                      >{{ " " }}{{ $t(proposition.p) }}</label
                    >
                  </div>
                </draggable>
              </table>
            </div>
          </transition>
        </div>
      </div>
      <div style="height:60px;" v-if="!is_finish" />
      <!-- si resultats du user autorisés -->
      <div class="bloc" v-if="retour_insight && is_finish">
        <RepondreResultatsAutorise
          :window="window"
          style="margin-bottom:5px;"
          class="bloc"
          :urlparticipant="urlparticipant"
          :name="this.insight_name"
          :thanks="this.insight_thanks"
          :insight_id="this.insight_id"
        />
      </div>
      <!-- si resultats du user non autorisés -->
      <div
        class="bloc"
        style="margin-bottom:5px;"
        v-if="!retour_insight && is_finish"
      >
        <RepondreResultatsNonAutorise
          :thanks="this.insight_thanks"
          :urlparticipant="urlparticipant"
        />
      </div>
    </div>
    <Footer :window="window" />
  </div>
</template>

<script>
import vueStep from "vue-step";
import Footer from "@/components/layout/Footer";
import axios from "axios";
import draggable from "vuedraggable";
import Header from "@/components/layout/Header";
import RepondreResultatsAutorise from "@/components/insight/PageRepondre/RepondreResultatsAutorise";
import RepondreResultatsNonAutorise from "@/components/insight/PageRepondre/RepondreResultatsNonAutorise";
import { mapGetters } from "vuex";
import EventBus from "../../eventBus";

export default {
  components: {
    Header,
    Footer,
    vueStep,
    draggable,
    RepondreResultatsAutorise,
    RepondreResultatsNonAutorise,
  },
  data() {
    return {
      nowStep: 1,
      affichageSuivant: false,
      question_en_cours: 1,
      insight_presentation_results: "",
      background: "",
      url_insight: process.env.VUE_APP_URL_MEDIA,
      urlparticipant: this.$route.params.urlparticipant,
      is_finish: this.$store.state.participant.insight_finish,
      orderIsOk: false,
      suivant: false,
      retour_insight: 0,
      color1: 0, // rouge
      color2: 0, // bleu
      color3: 0, // vert
      color4: 0, // jaune
      dominanteColor: [],
      inferiorColor: [],
      dataColors: [],
      insight_name: "",
      insight_id: 0,
      insight_thanks: "",
      errors: [],
      window: {
        width: window.innerWidth,
      },
    };
  },
  computed: {
    ...mapGetters([
      "insight_questions",
      "insight_arrayScore",
      "insight_arrayColorsString",
      "firstname",
      "lastname",
      "id_participant",
    ]),
    stepListCalc() {
      let tabQuestion = [];
      const questions = this.insight_questions.questions;
      questions.forEach(function(prop) {
        tabQuestion.push(prop.faussecle);
      });
      return tabQuestion;
    },
    nextStep() {
      let calcStep = this.nowStep + 1;
      this.suivant = false;
      //this.question_en_cours += 1;
      if (calcStep > this.stepListCalc.length) return this.nowStep;
      else return calcStep;
    },
    prevStep() {
      let calcStep = this.nowStep - 1;
      if (calcStep <= 0) return this.nowStep;
      else return calcStep;
    },
  },
  created() {
    this.handleResize();
    axios.defaults.headers.common["urlparticipant"] = this.urlparticipant;
    axios
      .get(process.env.VUE_APP_URL_SSO_API + "insight/insightcomplet")
      .then((response) => {
        this.insight_id = response.data.Insight.id;
        this.insight_name = response.data.Insight.name;
        this.insight_thanks = response.data.Insight.thanks;
        this.retour_insight = response.data.Insight.retour_insight;
        if (response.data.Insight.media)
          this.background =
            "background-size: cover;background-image:url('" +
            this.url_insight +
            response.data.Insight.media +
            "')";
        else {
          this.background =
            "background-size: cover;background-image:url(" +
            require("@/assets/img/bandeau/bandeau.jpg") +
            ")";
        }
      })
      .catch((error) => {
        this.errors.push(error);
        this.$buefy.toast.open({
          type: "is-danger",
          message: this.$i18n.t("toast.quizz_invalide"),
        });
        this.$router.push({ name: "home" });
      });
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.window.width = window.innerWidth;
    },
    calcColors() {
      // je récupère mon Json et j'initialise mes tableaux de couleurs vide
      let tab = this.insight_questions.questions;
      let propsTabColors = [];
      // je recupère les données des couleurs dans le tableau vide
      for (let i = 0; i < tab.length; i++) {
        let tabColors = [];
        for (let j = 0; j < tab[i].prop.length; j++) {
          tabColors.push(tab[i].prop[j].c);
        }
        propsTabColors.push(tabColors);
        this.propsTabColors = propsTabColors;
      }
      // je lis et compare les valeurs c1, c2, c3, c4 te je leur ajoute les valeurs correspondantes
      let c1 = 0; // rouge
      let c2 = 0; // bleu
      let c3 = 0; // vert
      let c4 = 0; // jaune
      const tabPoints = this.insight_arrayScore;
      let tabColorsStr = this.insight_arrayColorsString;
      let tabColorData = [c1, c2, c3, c4];
      for (let j = 0; j < propsTabColors.length; j++) {
        for (let z = 0; z < propsTabColors.length; z++) {
          for (let x = 0; x < propsTabColors.length; x++) {
            if (propsTabColors[j][z] === tabColorsStr[x]) {
              tabColorData[x] += tabPoints[z];
            }
          }
        }
      }
      // récupération des résultats pour les envoyer en BDD
      this.color1 += tabColorData[0];
      this.color2 += tabColorData[1];
      this.color3 += tabColorData[2];
      this.color4 += tabColorData[3];
      // calcul de la dominante basée sur 4 couleurs
      let dominante = [];
      let inferior = [];
      for (let i = 0; i < 4; i++) {
        let colors = [this.color1, this.color2, this.color3, this.color4];
        this.dataColors = colors;
        let max = [];
        let min = [];
        min[0] = 100;
        max[0] = -1;
        for (let j = 0; j < colors.length; j++) {
          if (max[0] < colors[j]) {
            max = [];
            max[0] = colors[j];
            dominante = [];
            dominante[0] = j;
          } else if (max[0] === colors[j]) {
            max.push(colors[j]);
            dominante.push(j);
          }
        }
        for (let j = 0; j < colors.length; j++) {
          if (min[0] > colors[j]) {
            min = [];
            min[0] = colors[j];
            inferior = [];
            inferior[0] = j;
          } else if (min[0] === colors[j]) {
            min.push(colors[j]);
            inferior.push(j);
          }
        }
      }
      this.dominanteColor.push(dominante, inferior);
    },

    toStep(step, direction) {
      if (direction == "next") this.affichageSuivant = false;
      else this.affichageSuivant = true;
      this.orderIsOk = false;
      this.nbr_max_coche_respecte = true;
      this.nowStep = step;
    },
    affichageSuivantOrderedChoices() {
      this.orderIsOk = true;
      this.suivant = true;
      this.affichageSuivant = true;
    },
    validateResponse() {
      this.calcColors();
      if (this.$store.state.participant.insight_finish == 0) {
        const form_values = new FormData();
        form_values.append("_method", "PUT");
        form_values.append("id", this.id_participant);
        form_values.append(
          "reponse",
          JSON.stringify(this.insight_questions.questions)
        );
        form_values.append("finish", 1);
        form_values.append("profil", JSON.stringify(this.dominanteColor));
        form_values.append("color1", this.color1); // rouge
        form_values.append("color2", this.color2); // bleu
        form_values.append("color3", this.color3); // vert
        form_values.append("color4", this.color4); // jaune
        this.$store.commit("UPDATE_INSIGHT_FINISH", 1);
        axios.defaults.headers.common["urlparticipant"] = this.urlparticipant;
        axios
          .post(
            process.env.VUE_APP_URL_SSO_API + "insight/insightreponse",
            form_values
          )
          .then((response) => {
            this.$store.commit("UPDATE_PARTICIPANT", [
              response.data.participant,
            ]);
            if (!this.retour_insight) {
              EventBus.$emit("counterDown", true);
            }
            this.is_finish = response.data.participant.finish;
            this.$buefy.toast.open({
              type: "is-success",
              message: this.$i18n.t("toast.reponseOK"),
            });
          })
          .catch((error) => {
            this.errors.push(error);
            this.$buefy.toast.open({
              type: "is-danger",
              message: this.$i18n.t("toast.reponse_invalide"),
            });
          });
      }
    },
  },
  changerInsight() {
    this.$router.push({ name: "home" });
  },
};
</script>
<style scoped>
button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  position: absolute;
  left: -6000px;
}
.is-info {
  background-color: #424a60 !important;
  color: white !important;
}
.is-info:hover {
  background-color: #424a60;
}
.ButtonSubmit {
  background-color: #f8df40 !important;
  color: #424a60 !important;
}
</style>
